<template>
  <tr>
    <td
      v-if="stage && stage.len"
      :rowspan="stage.len"
    >{{stage.title}}</td>
    <td>{{user.Profile.Name}}</td>
    <td>{{item.Content}}</td>
    <td>
      <span v-if="isMoneyVisible">{{(item.IssuedAt ? item.Bonus : item.Budget) | amountFormat}}</span>
      <span v-else>-</span>
    </td>
    <!-- <td>{{(item.Bonus) | amountFormat}}</td> -->
    <td>
      <span v-if="item.BonusReleasedAt">{{item.BonusReleasedAt | yearMonthFormat}}</span>
      <span v-else-if="item.IssuedAt">預計下個月薪水</span>
    </td>
    <td>{{bonusIssuer.Profile.Name}}</td>
  </tr>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import filterMixin from "@/data/filters/filter-mixin.vue";
export default {
  mixins: [filterMixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    stage: {
      type: Object,
      required: false
    },
    year: {
      project: Number,
      required: true
    },
    month: {
      project: Number,
      required: true
    }
  },
  data: () => ({}),
  computed: {
    user() {
      return this.users.find(o => o.ID == this.item.UserID);
    },
    bonusIssuer() {
      return (
        this.users.find(o => o.ID == this.item.BonusIssuerID) || { Profile: {} }
      );
    },
    isMoneyVisible () {
      return this.myLevel >= 10 || this.item.UserID == this.me.ID// || this.task.MangerID == this.me.ID
    },
    ...mapGetters(["users", "canEditTask", "myLevel", "me"])
  },
  methods: {}
};
</script>
